import React from 'react';
import { Divider } from 'semantic-ui-react';
import PropTypes from 'prop-types';

const DividerComponent = ({ children, className, hidden, clearing, horizontal, style, vertical, props }) => (
  <Divider
    clearing={clearing}
    horizontal={horizontal}
    hidden={hidden}
    className={className}
    style={style}
    vertical={vertical}
    {...props}
  >
    {children}
  </Divider>
);

DividerComponent.propTypes = {
  children: PropTypes.any,
  className: PropTypes.string,
  hidden: PropTypes.bool,
  clearing: PropTypes.bool,
  horizontal: PropTypes.bool,
  vertical: PropTypes.bool,
  style: PropTypes.object,
};
DividerComponent.defaultProps = {
  children: [],
  className: '',
  hidden: false,
  clearing: false,
  horizontal: false,
  vertical: false,
  style: {},
};

export default DividerComponent;



// WEBPACK FOOTER //
// ./src/components/Canvas/renderer/elements/divider/ThemeDivider.js